angular.module('app.filters').filter('reverse', () => (items) => items.slice().reverse());
